<template>
  <div ref="opData" id="opData" :class="activateComparison ? 'dataTables activateComparison' : 'dataTables'">
    <el-table ref="opCoderTable" v-if="grouping === '1'" key="byCoderOp" :data="isIE11 ? coderTablePagination : coderTableData" empty-text="No Coder Data Available" :height="400" :summary-method="getSummaries" show-summary stripe>
      <el-table-column prop="codeDesc" label="Code Type" sortable> </el-table-column>
      <el-table-column prop="coder" label="Coder" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.coder, filterCriteria)" :class="`opCoder_coder_${scope.$index} details`" @click="buildPivotDataStats('Coder Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, { table: 'opCoder', prop: 'coder', index: scope.$index, row: scope.row }, $event, scope.row.coder)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Coder ${scope.row.coder}`, scope.row, $event)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="apcCodes" label="Total APC" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total APC', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.apcCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opCoder_apcCodes_${scope.$index} details`" @click="buildPivotData('Total APC', scope.row.apcNoRec, scope.row.apcAdditions, scope.row.apcDeletions, scope.row.apcRevisions, { table: 'opCoder', prop: 'apcCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.apcCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope, null)">N/A</div>
          <div v-if="scope.row.totalCodes" v-html="highlightValue(`${(scope.row.totalCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opCoder_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.pxNoRec + scope.row.cptNoRec + scope.row.modNoRec + scope.row.emNoRec + scope.row.iiNoRec + scope.row.siNoRec, scope.row.dxAdditions + scope.row.pxAdditions + scope.row.cptAdditions + scope.row.modAdditions + scope.row.emAdditions + scope.row.iiAdditions + scope.row.siAdditions, scope.row.dxDeletions + scope.row.pxDeletions + scope.row.cptDeletions + scope.row.modDeletions + scope.row.emDeletions + scope.row.iiDeletions + scope.row.siDeletions, scope.row.dxRevisions + scope.row.pxRevisions + scope.row.cptRevisions + scope.row.modRevisions + scope.row.emRevisions + scope.row.iiRevisions + scope.row.siRevisions, { table: 'opCoder', prop: 'opTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Codes', scope, null)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opCoder_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'opCoder', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)">
            {{ `${(scope.row.cmCodes * 100).toFixed(2)}%` }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="pcsCodes" label="ICD-10 PCS Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 PCS Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.pcsCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opCoder_pcsCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 PCS Codes', scope.row.pxNoRec, scope.row.pxAdditions, scope.row.pxDeletions, scope.row.pxRevisions, { table: 'opCoder', prop: 'pcsCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.pcsCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="cptCodes" label="CPT Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('CPT Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opCoder_cptCodes_${scope.$index} details`" @click="buildPivotData('CPT Codes', scope.row.cptNoRec, scope.row.cptAdditions, scope.row.cptDeletions, scope.row.cptRevisions, { table: 'opCoder', prop: 'cptCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="modCodes" label="MOD Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('MOD Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.modCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opCoder_modCodes_${scope.$index} details`" @click="buildPivotData('MOD Codes', scope.row.modNoRec, scope.row.modAdditions, scope.row.modDeletions, scope.row.modRevisions, { table: 'opCoder', prop: 'modCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.modCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="emCodes" label="E/M Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('E/M Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.emCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opCoder_emCodes_${scope.$index} details`" @click="buildPivotData('E/M Codes', scope.row.emNoRec, scope.row.emAdditions, scope.row.emDeletions, scope.row.emRevisions, { table: 'opCoder', prop: 'emCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.emCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="iiCodes" label="I&I Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('I&I Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.iiCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opCoder_iiCodes_${scope.$index} details`" @click="buildPivotData('I&I Codes', scope.row.iiNoRec, scope.row.iiAdditions, scope.row.iiDeletions, scope.row.iiRevisions, { table: 'opCoder', prop: 'iiCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.iiCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="siCodes" label="S&I Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('S&I Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.siCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opCoder_siCodes_${scope.$index} details`" @click="buildPivotData('S&I Codes', scope.row.siNoRec, scope.row.siAdditions, scope.row.siDeletions, scope.row.siRevisions, { table: 'opCoder', prop: 'siCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.siCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="financialImpact" label="Financial Impact" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(moneyFormatter(scope.row.financialImpact), filterCriteria)" :class="`opCoder_financialImpact_${scope.$index} details ${scope.row.financialImpact < 0 ? 'negative' : ''}`" @click="buildPivotDataFinancials('Financial Stats', scope.row.financialImpact, scope.row.reimbInc, scope.row.reimbDec, scope.row.reimbIncRecords, scope.row.reimbDecRecords, { table: 'opCoder', prop: 'apcFinancialImpact', index: scope.$index, row: scope.row }, $event, moneyFormatter(scope.row.financialImpact))"></div>
        </template>
      </el-table-column>
    </el-table>
    <el-table ref="opCoderTrendingTable" v-if="grouping === '15'" key="byCoderOp" :data="isIE11 ? coderTrendingTablePagination : coderTrendingTableData" empty-text="No Coder Data Available" :height="400" :summary-method="getSummaries" show-summary stripe>
      <el-table-column prop="codeDesc" label="Code Type" sortable> </el-table-column>
      <el-table-column prop="coder" label="Coder" sortable>
        <template slot-scope="scope">
          <!-- <div v-html="highlightValue(scope.row.coder, filterCriteria)" :class="`opCoderTrending_coder_${scope.$index} details`" @click="buildPivotDataStats('Coder Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, { table: 'opCoder', prop: 'coder', index: scope.$index, row: scope.row }, $event)"></div> -->
          <div v-html="highlightValue(scope.row.coder, filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="projectName" label="Project" sortable>
        <template slot-scope="scope">
          <div :class="`opCoderTrending_coder_${scope.$index} details`" @click="buildPivotDataStats('Project Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, { table: 'opCoderTrending', prop: 'coder', index: scope.$index, row: scope.row }, $event, scope.row.projectName)" v-html="highlightValue(scope.row.projectName, filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="projectStartDate" label="Start Date" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(formatDate(scope.row.projectStartDate), filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Coder ${scope.row.coder}`, scope.row, $event)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="apcCodes" label="Total APC" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total APC', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.apcCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opCoderTrending_apcCodes_${scope.$index} details`" @click="buildPivotData('Total APC', scope.row.apcNoRec, scope.row.apcAdditions, scope.row.apcDeletions, scope.row.apcRevisions, { table: 'opCoderTrending', prop: 'apcCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.apcCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope, null)">N/A</div>
          <div v-if="scope.row.totalCodes" v-html="highlightValue(`${(scope.row.totalCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opCoderTrending_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.pxNoRec + scope.row.cptNoRec + scope.row.modNoRec + scope.row.emNoRec + scope.row.iiNoRec + scope.row.siNoRec, scope.row.dxAdditions + scope.row.pxAdditions + scope.row.cptAdditions + scope.row.modAdditions + scope.row.emAdditions + scope.row.iiAdditions + scope.row.siAdditions, scope.row.dxDeletions + scope.row.pxDeletions + scope.row.cptDeletions + scope.row.modDeletions + scope.row.emDeletions + scope.row.iiDeletions + scope.row.siDeletions, scope.row.dxRevisions + scope.row.pxRevisions + scope.row.cptRevisions + scope.row.modRevisions + scope.row.emRevisions + scope.row.iiRevisions + scope.row.siRevisions, { table: 'opCoderTrending', prop: 'opTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Codes', scope, null)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opCoderTrending_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'opCoderTrending', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)">
            {{ `${(scope.row.cmCodes * 100).toFixed(2)}%` }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="pcsCodes" label="ICD-10 PCS Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 PCS Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.pcsCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opCoderTrending_pcsCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 PCS Codes', scope.row.pxNoRec, scope.row.pxAdditions, scope.row.pxDeletions, scope.row.pxRevisions, { table: 'opCoderTrending', prop: 'pcsCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.pcsCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="cptCodes" label="CPT Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('CPT Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opCoderTrending_cptCodes_${scope.$index} details`" @click="buildPivotData('CPT Codes', scope.row.cptNoRec, scope.row.cptAdditions, scope.row.cptDeletions, scope.row.cptRevisions, { table: 'opCoderTrending', prop: 'cptCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="modCodes" label="MOD Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('MOD Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.modCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opCoderTrending_modCodes_${scope.$index} details`" @click="buildPivotData('MOD Codes', scope.row.modNoRec, scope.row.modAdditions, scope.row.modDeletions, scope.row.modRevisions, { table: 'opCoderTrending', prop: 'modCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.modCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="emCodes" label="E/M Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('E/M Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.emCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opCoderTrending_emCodes_${scope.$index} details`" @click="buildPivotData('E/M Codes', scope.row.emNoRec, scope.row.emAdditions, scope.row.emDeletions, scope.row.emRevisions, { table: 'opCoderTrending', prop: 'emCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.emCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="iiCodes" label="I&I Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('I&I Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.iiCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opCoderTrending_iiCodes_${scope.$index} details`" @click="buildPivotData('I&I Codes', scope.row.iiNoRec, scope.row.iiAdditions, scope.row.iiDeletions, scope.row.iiRevisions, { table: 'opCoderTrending', prop: 'iiCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.iiCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="siCodes" label="S&I Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('S&I Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.siCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opCoderTrending_siCodes_${scope.$index} details`" @click="buildPivotData('S&I Codes', scope.row.siNoRec, scope.row.siAdditions, scope.row.siDeletions, scope.row.siRevisions, { table: 'opCoderTrending', prop: 'siCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.siCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="financialImpact" label="Financial Impact" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(moneyFormatter(scope.row.financialImpact), filterCriteria)" :class="`opCoderTrending_financialImpact_${scope.$index} details ${scope.row.financialImpact < 0 ? 'negative' : ''}`" @click="buildPivotDataFinancials('Financial Stats', scope.row.financialImpact, scope.row.reimbInc, scope.row.reimbDec, scope.row.reimbIncRecords, scope.row.reimbDecRecords, { table: 'opCoderTrending', prop: 'apcFinancialImpact', index: scope.$index, row: scope.row }, $event, moneyFormatter(scope.row.financialImpact))"></div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="opApcTable" v-if="grouping === '2'" key="byApcOp" :data="isIE11 ? apcTableDataPagination : apcTableData" :fit="true" empty-text="No APC Data Available" :summary-method="getAPCSummary" show-summary :height="400" stripe>
      <el-table-column v-if="activateComparison && comparisonAccountsOP.length" prop="codeDesc" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.codeDesc" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc" v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('apc', scope.row.apc, 'codeDesc', scope.row.codeDesc, false, scope.row.patType) }}
          </div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('apc', scope.row.apc, 'codeDesc', scope.row.codeDesc, true, scope.row.patType) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="apc" label="APC" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.apc, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('apc', scope.row.apc, 'apc', scope.row.codeDesc, false, scope.row.patType) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('apc', scope.row.apc, 'apc', scope.row.codeDesc, true, scope.row.patType) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="patType" label="Patient Type" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.patType" v-html="highlightValue(scope.row.patType, filterCriteria)"></div>
          <div :title="scope.row.patType" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('apc', scope.row.apc, 'patType', scope.row.codeDesc, false, scope.row.patType) }}
          </div>
          <div :title="scope.row.patType" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('apc', scope.row.apc, 'patType', scope.row.codeDesc, true, scope.row.patType) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="apcCodes" label="Total APC" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total APC', scope, 'apc')">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.apcCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`codeType_apcCodes_${scope.$index} details`" @click="buildPivotData('Total APC', scope.row.noRec, scope.row.additions, scope.row.deletions, scope.row.revisions, { table: 'codeType', prop: 'apcCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.apcCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('apc', scope.row.apc, 'apcCodes', scope.row.codeDesc, false, scope.row.patType) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('apc', scope.row.apc, 'apcCodes', scope.row.codeDesc, true, scope.row.patType) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('apc', scope.row.apc, 'numClients', scope.row.codeDesc, false, scope.row.patType) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('apc', scope.row.apc, 'numClients', scope.row.codeDesc, true, scope.row.patType) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="financialImpact" label="Financial Impact" sortable>
        <template slot-scope="scope">
          <!-- <div
            :class="`codeType_financialImpact_${scope.$index} details ${scope.row.financialImpact < 0 ? 'negative' : ''}` "
            @click="buildPivotDataFinancials('Financial Stats', scope.row.financialImpact, scope.row.reimbInc, scope.row.reimbDec, scope.row.reimbIncRecords, scope.row.reimbDecRecords,  {table: 'codeType', prop: 'apcFinancialImpact', index: scope.$index, row: scope.row})">
            {{ moneyFormatter(scope.row.financialImpact)}}</div> -->
          <div :class="scope.row.financialImpact < 0 ? 'negative' : ''" v-html="highlightValue(moneyFormatter(scope.row.financialImpact), filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length" :class="getBedSizeValue('apc', scope.row.apc, 'financialImpact', scope.row.codeDesc, false).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('apc', scope.row.apc, 'financialImpact', scope.row.codeDesc, false, scope.row.patType) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length" :class="getBedSizeValue('apc', scope.row.apc, 'financialImpact', scope.row.codeDesc, true).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('apc', scope.row.apc, 'financialImpact', scope.row.codeDesc, true, scope.row.patType) }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="opPatientTypeTable" v-if="grouping === '3'" key="byPatTypeOp" :data="isIE11 ? patientTypeTablePagination : patientTypeTableData" :fit="true" empty-text="No Patient Type Data Available" :height="400" :summary-method="getSummaries" show-summary stripe>
      <el-table-column v-if="activateComparison && comparisonAccountsOP.length" prop="codeDesc" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.codeDesc" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc">{{ scope.row.codeDesc }}</div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'codeDesc', scope.row.codeDesc, false) }}
          </div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'codeDesc', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="patTypeDesc" label="Patient Type" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.patTypeDesc" v-html="highlightValue(scope.row.patTypeDesc, filterCriteria)" :class="`code_patTypeDesc_${scope.$index} details`" @click="buildPivotDataStats('Patient Type Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, { table: 'code', prop: 'patTypeDesc', index: scope.$index, row: scope.row }, $event, scope.row.patTypeDesc)"></div>
          <div :title="scope.row.patTypeDesc" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'patTypeDesc', scope.row.codeDesc, false) }}
          </div>
          <div :title="scope.row.patTypeDesc" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'patTypeDesc', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Patient Type ${scope.row.patTypeDesc}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'totalRecords', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'totalRecords', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'numClients', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'numClients', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="apcCodes" label="Total APC" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total APC', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.apcCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`code_apcCodes_${scope.$index} details`" @click="buildPivotData('Total APC', scope.row.apcNoRec, scope.row.apcAdditions, scope.row.apcDeletions, scope.row.apcRevisions, { table: 'code', prop: 'apcCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.apcCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'apcCodes', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'apcCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.totalCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`code_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.pxNoRec + scope.row.cptNoRec + scope.row.modNoRec + scope.row.emNoRec + scope.row.iiNoRec + scope.row.siNoRec, scope.row.dxAdditions + scope.row.pxAdditions + scope.row.cptAdditions + scope.row.modAdditions + scope.row.emAdditions + scope.row.iiAdditions + scope.row.siAdditions, scope.row.dxDeletions + scope.row.pxDeletions + scope.row.cptDeletions + scope.row.modDeletions + scope.row.emDeletions + scope.row.iiDeletions + scope.row.siDeletions, scope.row.dxRevisions + scope.row.pxRevisions + scope.row.cptRevisions + scope.row.modRevisions + scope.row.emRevisions + scope.row.iiRevisions + scope.row.siRevisions, { table: 'code', prop: 'opTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'totalCodes', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'totalCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`code_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'code', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'cmCodes', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'cmCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="pcsCodes" label="ICD-10 PCS Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 PCS Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.pcsCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`code_pcsCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 PCS Codes', scope.row.pxNoRec, scope.row.pxAdditions, scope.row.pxDeletions, scope.row.pxRevisions, { table: 'code', prop: 'pcsCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.pcsCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'pcsCodes', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'pcsCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cptCodes" label="CPT Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('CPT Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`code_cptCodes_${scope.$index} details`" @click="buildPivotData('CPT Codes', scope.row.cptNoRec, scope.row.cptAdditions, scope.row.cptDeletions, scope.row.cptRevisions, { table: 'code', prop: 'cptCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'cptCodes', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'cptCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="modCodes" label="MOD Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('MOD Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.modCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`code_modCodes_${scope.$index} details`" @click="buildPivotData('MOD Codes', scope.row.modNoRec, scope.row.modAdditions, scope.row.modDeletions, scope.row.modRevisions, { table: 'code', prop: 'modCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.modCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'modCodes', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'modCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="emCodes" label="E/M Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('E/M Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.emCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`code_emCodes_${scope.$index} details`" @click="buildPivotData('E/M Codes', scope.row.emNoRec, scope.row.emAdditions, scope.row.emDeletions, scope.row.emRevisions, { table: 'code', prop: 'emCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.emCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'emCodes', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'emCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="iiCodes" label="I&I Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('I&I Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.iiCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`code_iiCodes_${scope.$index} details`" @click="buildPivotData('I&I Codes', scope.row.iiNoRec, scope.row.iiAdditions, scope.row.iiDeletions, scope.row.iiRevisions, { table: 'code', prop: 'iiCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.iiCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'iiCodes', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'iiCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="siCodes" label="S&I Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('S&I Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.siCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`code_siCodes_${scope.$index} details`" @click="buildPivotData('I&I Codes', scope.row.iiNoRec, scope.row.iiAdditions, scope.row.iiDeletions, scope.row.iiRevisions, { table: 'code', prop: 'siCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.siCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'siCodes', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'siCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="financialImpact" label="Financial Impact" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(moneyFormatter(scope.row.financialImpact), filterCriteria)" :class="`code_financialImpact_${scope.$index} details ${scope.row.financialImpact < 0 ? 'negative' : ''}`" @click="buildPivotDataFinancials('Financial Stats', scope.row.financialImpact, scope.row.reimbInc, scope.row.reimbDec, scope.row.reimbIncRecords, scope.row.reimbDecRecords, { table: 'code', prop: 'apcFinancialImpact', index: scope.$index, row: scope.row }, $event, moneyFormatter(scope.row.financialImpact))"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length" :class="getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'financialImpact', scope.row.codeDesc, false).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'financialImpact', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length" :class="getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'financialImpact', scope.row.codeDesc, true).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'financialImpact', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="opFacilityTable" v-if="grouping === '5'" key="byFacilityOp" :data="isIE11 ? facilityTablePagination : facilityTableData" :fit="true" empty-text="No Patient Type Data Available" :height="400" :summary-method="getSummaries" show-summary stripe>
      <el-table-column v-if="activateComparison && comparisonAccountsOP.length" prop="codeDesc" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.codeDesc" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc">{{ scope.row.codeDesc }}</div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'codeDesc', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'codeDesc', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cliName" label="Facility" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.cliName" v-html="highlightValue(scope.row.cliName, filterCriteria)" :class="`opFacility_cliName_${scope.$index} details`" @click="buildPivotDataStats('Facility Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, { table: 'opFacility', prop: 'cliName', index: scope.$index, row: scope.row }, $event, scope.row.cliName)"></div>
          <div :title="`${bedSize} bed size reviews`" v-if="activateComparison && comparisonAccountsOP.length">
            {{ `${bedSize} bed size reviews` }}
          </div>
          <div title="All bed size reviews" v-if="activateComparison && comparisonAccountsOP.length">
            All bed size reviews
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Facility ${scope.row.cliName}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'totalRecords', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'totalRecords', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'numClients', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'numClients', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="apcCodes" label="Total APC" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total APC', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.apcCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opFacility_apcCodes_${scope.$index} details`" @click="buildPivotData('Total APC', scope.row.apcNoRec, scope.row.apcAdditions, scope.row.apcDeletions, scope.row.apcRevisions, { table: 'opFacility', prop: 'apcCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.apcCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'apcCodes', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'apcCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.totalCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opFacility_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.pxNoRec + scope.row.cptNoRec + scope.row.modNoRec + scope.row.emNoRec + scope.row.iiNoRec + scope.row.siNoRec, scope.row.dxAdditions + scope.row.pxAdditions + scope.row.cptAdditions + scope.row.modAdditions + scope.row.emAdditions + scope.row.iiAdditions + scope.row.siAdditions, scope.row.dxDeletions + scope.row.pxDeletions + scope.row.cptDeletions + scope.row.modDeletions + scope.row.emDeletions + scope.row.iiDeletions + scope.row.siDeletions, scope.row.dxRevisions + scope.row.pxRevisions + scope.row.cptRevisions + scope.row.modRevisions + scope.row.emRevisions + scope.row.iiRevisions + scope.row.siRevisions, { table: 'opFacility', prop: 'opTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'totalCodes', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'totalCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opFacility_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'opFacility', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'cmCodes', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'cmCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="pcsCodes" label="ICD-10 PCS Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 PCS Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.pcsCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opFacility_pcsCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 PCS Codes', scope.row.pxNoRec, scope.row.pxAdditions, scope.row.pxDeletions, scope.row.pxRevisions, { table: 'opFacility', prop: 'pcsCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.pcsCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'pcsCodes', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'pcsCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cptCodes" label="CPT Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('CPT Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opFacility_cptCodes_${scope.$index} details`" @click="buildPivotData('CPT Codes', scope.row.cptNoRec, scope.row.cptAdditions, scope.row.cptDeletions, scope.row.cptRevisions, { table: 'opFacility', prop: 'cptCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'cptCodes', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'cptCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="modCodes" label="MOD Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('MOD Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.modCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opFacility_modCodes_${scope.$index} details`" @click="buildPivotData('MOD Codes', scope.row.modNoRec, scope.row.modAdditions, scope.row.modDeletions, scope.row.modRevisions, { table: 'opFacility', prop: 'modCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.modCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'modCodes', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'modCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="emCodes" label="E/M Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('E/M Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.emCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opFacility_emCodes_${scope.$index} details`" @click="buildPivotData('E/M Codes', scope.row.emNoRec, scope.row.emAdditions, scope.row.emDeletions, scope.row.emRevisions, { table: 'opFacility', prop: 'emCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.emCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'emCodes', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'emCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="iiCodes" label="I&I Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('I&I Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.iiCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opFacility_iiCodes_${scope.$index} details`" @click="buildPivotData('I&I Codes', scope.row.iiNoRec, scope.row.iiAdditions, scope.row.iiDeletions, scope.row.iiRevisions, { table: 'opFacility', prop: 'iiCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.iiCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'iiCodes', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'iiCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="siCodes" label="S&I Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('S&I Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.siCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opFacility_siCodes_${scope.$index} details`" @click="buildPivotData('I&I Codes', scope.row.siNoRec, scope.row.siAdditions, scope.row.siDeletions, scope.row.siRevisions, { table: 'opFacility', prop: 'siCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.siCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'siCodes', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'siCodes', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="financialImpact" label="Financial Impact" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(moneyFormatter(scope.row.financialImpact), filterCriteria)" :class="`opFacility_financialImpact_${scope.$index} details ${scope.row.financialImpact < 0 ? 'negative' : ''}`" @click="buildPivotDataFinancials('Financial Stats', scope.row.financialImpact, scope.row.reimbInc, scope.row.reimbDec, scope.row.reimbIncRecords, scope.row.reimbDecRecords, { table: 'opFacility', prop: 'apcFinancialImpact', index: scope.$index, row: scope.row }, $event, moneyFormatter(scope.row.financialImpact))"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length" :class="getBedSizeValue('cliName', scope.row.cliName, 'financialImpact', scope.row.codeDesc, false).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'financialImpact', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length" :class="getBedSizeValue('cliName', scope.row.cliName, 'financialImpact', scope.row.codeDesc, true).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'financialImpact', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="opReasonTable" v-if="grouping === '6'" key="byReasonOp" :data="isIE11 ? reasonTablePagination : reasonTableData" :fit="true" empty-text="No Reason Data Available" :summary-method="getSummaries" show-summary :height="400" stripe>
      <el-table-column v-if="activateComparison && comparisonAccountsOP.length" prop="codeDesc" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.codeDesc" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc" v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('description', scope.row.description, 'codeDesc', scope.row.codeDesc, false) }}
          </div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('description', scope.row.description, 'codeDesc', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Reason" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('description', scope.row.description, 'description', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('description', scope.row.description, 'description', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="number" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.number, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`APC Reason ${scope.row.description}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('description', scope.row.description, 'number', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('description', scope.row.description, 'number', scope.row.codeDesc, true) }}
          </div>
        </template>
        <!-- <template slot-scope="scope">
          <div title="View Account Numbers" class="details"
            @click="buildAccountNumbers(`Reason ${scope.row.description}`, scope.row, $event)">
            {{scope.row.number}}
          </div>
        </template> -->
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('description', scope.row.description, 'numClients', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('description', scope.row.description, 'numClients', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="patType" label="Patient Type" sortable>
      </el-table-column>
      <el-table-column prop="apcCodes" label="Total APC" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total APC', scope, 'apc')">N/A</div>
          <div v-else :class="`codeType_apcCodes_${scope.$index} details`"
            @click="buildPivotData('Total APC', scope.row.noRec, scope.row.additions, scope.row.deletions, scope.row.revisions,  {table: 'codeType', prop: 'apcCodes', index: scope.$index, row: scope.row})">
            {{ `${(scope.row.apcCodes * 100).toFixed(2)}%` }}</div>
        </template>
      </el-table-column> -->
      <el-table-column prop="amt" label="Financial Impact" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(moneyFormatter(scope.row.amt), filterCriteria)" :class="`opReason_amt_${scope.$index} details ${scope.row.amt < 0 ? 'negative' : ''}`" @click="buildPivotDataFinancials('Financial Stats', scope.row.amt, scope.row.reimbInc, scope.row.reimbDec, scope.row.reimbIncRecords, scope.row.reimbDecRecords, { table: 'opReason', prop: 'apcFinancialImpact', index: scope.$index, row: scope.row }, $event, moneyFormatter(scope.row.amt))">
            {{ moneyFormatter(scope.row.amt) }}
          </div>
          <!-- <span :class="scope.row.amt < 0 ? 'negative' : ''">{{moneyFormatter(scope.row.amt)}}</span> -->
          <div v-if="activateComparison && comparisonAccountsOP.length" :class="getBedSizeValue('description', scope.row.description, 'amt', scope.row.codeDesc, false).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('description', scope.row.description, 'amt', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length" :class="getBedSizeValue('description', scope.row.description, 'amt', scope.row.codeDesc, true).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('description', scope.row.description, 'amt', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="opHeaderReasonTable" v-if="grouping === '7'" key="byHeaderReasonOp" :data="isIE11 ? headerReasonTablePagniation : headerReasonTableData" empty-text="No Reason Data Available" :height="400" stripe :summary-method="getSummaries" show-summary>
      <el-table-column v-if="activateComparison && comparisonAccountsOP.length" prop="changeReason" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.changeReason" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="changeReason" label="Reason" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.changeReason, filterCriteria)" :class="`headerreason_changeReason_${scope.$index} details`" @click="buildPivotDataStats('Reason Stats', scope.row.numRecords, scope.row.reimbIncreases, scope.row.reimbDecreases, scope.row.changeReason === 0 ? 0 : scope.row.numRecords, { table: 'headerreason', prop: 'changeReason', index: scope.$index, row: scope.row }, $event, scope.row.changeReason)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('changeDesc', scope.row.changeDesc, 'changeReason', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('changeDesc', scope.row.changeDesc, 'changeReason', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="changeDesc" label="Description" sortable>
        <template slot-scope="scope">
          <div>{{ scope.row.changeDesc }}</div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('changeDesc', scope.row.changeDesc, 'changeDesc', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('changeDesc', scope.row.changeDesc, 'changeDesc', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="numRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Reason ${scope.row.changeReason}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('changeDesc', scope.row.changeDesc, 'numRecords', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('changeDesc', scope.row.changeDesc, 'numRecords', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('changeDesc', scope.row.changeDesc, 'numClients', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('changeDesc', scope.row.changeDesc, 'numClients', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="financialImpact" label="Reimbursement Diff" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(moneyFormatter(scope.row.financialImpact), filterCriteria)" :class="`headerreason_reimbDiff_${scope.$index} details ${scope.row.financialImpact < 0 ? 'negative' : ''}`" @click="buildPivotDataFinancials('Financial Stats', scope.row.financialImpact, scope.row.reimbIncreases, scope.row.reimbDecreases, scope.row.recordsWithIncreases, scope.row.recordsWithDecreases, { table: 'headerreason', prop: 'reimbDiff', index: scope.$index, row: scope.row }, $event, moneyFormatter(scope.row.financialImpact))"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length" :class="getBedSizeValue('changeDesc', scope.row.changeDesc, 'financialImpact', scope.row.codeDesc, false).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('changeDesc', scope.row.changeDesc, 'financialImpact', scope.row.codeDesc, false) }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length" :class="getBedSizeValue('changeDesc', scope.row.changeDesc, 'financialImpact', scope.row.codeDesc, true).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('changeDesc', scope.row.changeDesc, 'financialImpact', scope.row.codeDesc, true) }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="opDxTable" v-if="grouping === '8'" key="byDxOp" :data="isIE11 || isCodeGrouping() ? dxTablePagination : dxTableData" empty-text="No Dx Data Available" :height="400" stripe :summary-method="getSummaries" show-summary @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccountsOP.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable="custom">
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc" v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, false, null, 'dx') }}
          </div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, true, null, 'dx') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="Code" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.code, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, false, null, 'dx') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, true, null, 'dx') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, false, null, 'dx') }}
          </div>
          <div tag="description" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, true, null, 'dx') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Dx Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, false, null, 'dx') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, true, null, 'dx') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, false, null, 'dx') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, true, null, 'dx') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opdx_cmCodes_${scope.$index} details`" @click="buildPivotData('Dx Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'opdx', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'cmCodes', scope.row.codeDesc, false, null, 'dx') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'cmCodes', scope.row.codeDesc, true, null, 'dx') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="opSdohTable" v-if="grouping === '14'" key="bySdohOp" :data="isIE11 || isCodeGrouping() ? sdohTablePagination : sdohTableData" empty-text="No SDOH Dx Data Available" :height="400" stripe :summary-method="getSummaries" show-summary @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccountsOP.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable="custom">
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc" v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, false, null, 'sdoh') }}
          </div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, true, null, 'sdoh') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="Code" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.code, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, false, null, 'sdoh') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, true, null, 'sdoh') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, false, null, 'sdoh') }}
          </div>
          <div tag="description" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, true, null, 'sdoh') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Dx SDOH Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, false, null, 'sdoh') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, true, null, 'sdoh') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, false, null, 'sdoh') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, true, null, 'sdoh') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opdx_cmCodes_${scope.$index} details`" @click="buildPivotData('SDOH Dx Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'opdx', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'cmCodes', scope.row.codeDesc, false, null, 'sdoh') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'cmCodes', scope.row.codeDesc, true, null, 'sdoh') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="opHCCTable" v-if="grouping === '12'" key="byHccOp" :data="isIE11 || isCodeGrouping() ? hccTablePagination : hccTableData" empty-text="No HCC V24 Data Available" :height="400" stripe :summary-method="getSummaries" show-summary @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccountsOP.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable="custom">
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc" v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, false, null, 'hcc') }}
          </div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, true, null, 'hcc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="HCC" sortable="custom">
        <template slot-scope="scope">
          <div class="details" v-html="highlightValue(scope.row.code, filterCriteria)" @click="buildDxPopover(`${scope.row.description}`, scope.row, $event, 'HCCV24')"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, false, null, 'hcc') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, true, null, 'hcc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, false, null, 'hcc') }}
          </div>
          <div tag="description" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, true, null, 'hcc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Dx Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, false, null, 'hcc') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, true, null, 'hcc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, false, null, 'hcc') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, true, null, 'hcc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="accuracyRate" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.accuracyRate * 100).toFixed(2)}%`, filterCriteria)" :class="`ophcc_accuracyRate_${scope.$index} details`" @click="buildPivotData('HCC V24 Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'ophcc', prop: 'hccV24AccuracyRate', index: scope.$index, row: scope.row }, $event, `${(scope.row.accuracyRate * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'accuracyRate', scope.row.codeDesc, false, null, 'hcc') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'accuracyRate', scope.row.codeDesc, true, null, 'hcc') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="opHCCV28Table" v-if="grouping === '13'" key="byHccV28Op" :data="isIE11 || isCodeGrouping() ? hccV28TablePagination : hccV28TableData" empty-text="No HCC V28 Data Available" :height="400" stripe :summary-method="getSummaries" show-summary @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccountsOP.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable="custom">
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc" v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, false, null, 'hccv28') }}
          </div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, true, null, 'hccv28') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="HCC" sortable="custom">
        <template slot-scope="scope">
          <div class="details" v-html="highlightValue(scope.row.code, filterCriteria)" @click="buildDxPopover(`${scope.row.description}`, scope.row, $event, 'HCCV28')"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, false, null, 'hccv28') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, true, null, 'hccv28') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, false, null, 'hccv28') }}
          </div>
          <div tag="description" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, true, null, 'hccv28') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Dx Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, false, null, 'hccv28') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, true, null, 'hccv28') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, false, null, 'hccv28') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, true, null, 'hccv28') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="accuracyRate" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.accuracyRate * 100).toFixed(2)}%`, filterCriteria)" :class="`ophccv28_accuracyRate_${scope.$index} details`" @click="buildPivotData('HCC V28 Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'ophccv28', prop: 'hccV28AccuracyRate', index: scope.$index, row: scope.row }, $event, `${(scope.row.accuracyRate * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'accuracyRate', scope.row.codeDesc, false, null, 'hccv28') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'accuracyRate', scope.row.codeDesc, true, null, 'hccv28') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="opCptTable" v-if="grouping === '9'" key="byCptOp" :data="isIE11 || isCodeGrouping() ? cptTablePagination : cptTableData" empty-text="No CPT Data Available" :height="400" stripe :summary-method="getSummaries" show-summary @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccountsOP.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable="custom">
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc" v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, false, null, 'cpt') }}
          </div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, true, null, 'cpt') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="Code" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.code, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, false, null, 'cpt') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, true, null, 'cpt') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, false, null, 'cpt') }}
          </div>
          <div tag="description" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, true, null, 'cpt') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`CPT Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, false, null, 'cpt') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, true, null, 'cpt') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, false, null, 'cpt') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, true, null, 'cpt') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cptCodes" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opcpt_cptCodes_${scope.$index} details`" @click="buildPivotData('CPT Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'opcpt', prop: 'cptCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'cptCodes', scope.row.codeDesc, false, null, 'cpt') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'cptCodes', scope.row.codeDesc, true, null, 'cpt') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="opModTable" v-if="grouping === '10'" key="byModOp" :data="isIE11 ? modTablePagination : modTableData" empty-text="No MOD Data Available" :height="400" stripe :summary-method="getSummaries" show-summary>
      <el-table-column v-if="activateComparison && comparisonAccountsOP.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc" v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, false, null, 'mod') }}
          </div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, true, null, 'mod') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="Code" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.code, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, false, null, 'mod') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, true, null, 'mod') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable>
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, false, null, 'mod') }}
          </div>
          <div tag="description" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, true, null, 'mod') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`MOD Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, false, null, 'mod') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, true, null, 'mod') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, false, null, 'mod') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, true, null, 'mod') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="modCodes" label="Accuracy Rate" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('mod modCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.modCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opmod_modCodes_${scope.$index} details`" @click="buildPivotData('MOD Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'opmod', prop: 'modCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.modCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'modCodes', scope.row.codeDesc, false, null, 'mod') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'modCodes', scope.row.codeDesc, true, null, 'mod') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="opPxTable" v-if="grouping === '11'" key="byPxOp" :data="isIE11 || isCodeGrouping() ? pxTablePagination : pxTableData" empty-text="No Px Data Available" :height="400" stripe :summary-method="getSummaries" show-summary @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccountsOP.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="codeDesc" label="Code Type" sortable="custom">
        <template slot-scope="scope">
          <div :title="scope.row.codeDesc" v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, false, null, 'px') }}
          </div>
          <div :title="scope.row.codeDesc" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'codeDesc', scope.row.codeDesc, true, null, 'px') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="Code" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.code, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, false, null, 'px') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', scope.row.codeDesc, true, null, 'px') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, false, null, 'px') }}
          </div>
          <div tag="description" v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', scope.row.codeDesc, true, null, 'px') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Px Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, false, null, 'px') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', scope.row.codeDesc, true, null, 'px') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, false, null, 'px') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', scope.row.codeDesc, true, null, 'px') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="pcsCodes" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.pcsCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`oppx_pcsCodes_${scope.$index} details`" @click="buildPivotData('Px Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'oppx', prop: 'pcsCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.pcsCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'pcsCodes', scope.row.codeDesc, false, null, 'px') }}
          </div>
          <div v-if="activateComparison && comparisonAccountsOP.length">
            {{ getBedSizeValue('code', scope.row.code, 'pcsCodes', scope.row.codeDesc, true, null, 'px') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="opServiceLineTable" v-if="grouping === '16'" key="byCoderOp" :data="isIE11 ? serviceLineTablePagination : serviceLineTableData" empty-text="No Service Line Data Available" :height="400" :summary-method="getSummaries" show-summary stripe>
      <el-table-column prop="codeDesc" label="Code Type" sortable> </el-table-column>
      <el-table-column prop="clientServiceLineName" label="Service Line" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.clientServiceLineName, filterCriteria)" :class="`opServiceLine_clientServiceLineName_${scope.$index} details`" @click="buildPivotDataStats('Service Line Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, { table: 'opServiceLine', prop: 'clientServiceLineName', index: scope.$index, row: scope.row }, $event, scope.row.clientServiceLineName)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Coder ${scope.row.coder}`, scope.row, $event)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="apcCodes" label="Total APC" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total APC', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.apcCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opServiceLine_apcCodes_${scope.$index} details`" @click="buildPivotData('Total APC', scope.row.apcNoRec, scope.row.apcAdditions, scope.row.apcDeletions, scope.row.apcRevisions, { table: 'opServiceLine', prop: 'apcCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.apcCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope, null)">N/A</div>
          <div v-if="scope.row.totalCodes" v-html="highlightValue(`${(scope.row.totalCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opServiceLine_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.pxNoRec + scope.row.cptNoRec + scope.row.modNoRec + scope.row.emNoRec + scope.row.iiNoRec + scope.row.siNoRec, scope.row.dxAdditions + scope.row.pxAdditions + scope.row.cptAdditions + scope.row.modAdditions + scope.row.emAdditions + scope.row.iiAdditions + scope.row.siAdditions, scope.row.dxDeletions + scope.row.pxDeletions + scope.row.cptDeletions + scope.row.modDeletions + scope.row.emDeletions + scope.row.iiDeletions + scope.row.siDeletions, scope.row.dxRevisions + scope.row.pxRevisions + scope.row.cptRevisions + scope.row.modRevisions + scope.row.emRevisions + scope.row.iiRevisions + scope.row.siRevisions, { table: 'opServiceLine', prop: 'opTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Codes', scope, null)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opServiceLine_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'opServiceLine', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)">
            {{ `${(scope.row.cmCodes * 100).toFixed(2)}%` }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="pcsCodes" label="ICD-10 PCS Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 PCS Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.pcsCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opServiceLine_pcsCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 PCS Codes', scope.row.pxNoRec, scope.row.pxAdditions, scope.row.pxDeletions, scope.row.pxRevisions, { table: 'opServiceLine', prop: 'pcsCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.pcsCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="cptCodes" label="CPT Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('CPT Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.cptCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opServiceLine_cptCodes_${scope.$index} details`" @click="buildPivotData('CPT Codes', scope.row.cptNoRec, scope.row.cptAdditions, scope.row.cptDeletions, scope.row.cptRevisions, { table: 'opServiceLine', prop: 'cptCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cptCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="modCodes" label="MOD Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('MOD Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.modCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opServiceLine_modCodes_${scope.$index} details`" @click="buildPivotData('MOD Codes', scope.row.modNoRec, scope.row.modAdditions, scope.row.modDeletions, scope.row.modRevisions, { table: 'opServiceLine', prop: 'modCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.modCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="emCodes" label="E/M Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('E/M Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.emCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opServiceLine_emCodes_${scope.$index} details`" @click="buildPivotData('E/M Codes', scope.row.emNoRec, scope.row.emAdditions, scope.row.emDeletions, scope.row.emRevisions, { table: 'opServiceLine', prop: 'emCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.emCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="iiCodes" label="I&I Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('I&I Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.iiCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opServiceLine_iiCodes_${scope.$index} details`" @click="buildPivotData('I&I Codes', scope.row.iiNoRec, scope.row.iiAdditions, scope.row.iiDeletions, scope.row.iiRevisions, { table: 'opServiceLine', prop: 'iiCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.iiCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="siCodes" label="S&I Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('S&I Codes', scope, null)">N/A</div>
          <div v-else v-html="highlightValue(`${(scope.row.siCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`opServiceLine_siCodes_${scope.$index} details`" @click="buildPivotData('S&I Codes', scope.row.siNoRec, scope.row.siAdditions, scope.row.siDeletions, scope.row.siRevisions, { table: 'opServiceLine', prop: 'siCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.siCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="financialImpact" label="Financial Impact" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(moneyFormatter(scope.row.financialImpact), filterCriteria)" :class="`opServiceLine_financialImpact_${scope.$index} details ${scope.row.financialImpact < 0 ? 'negative' : ''}`" @click="buildPivotDataFinancials('Financial Stats', scope.row.financialImpact, scope.row.reimbInc, scope.row.reimbDec, scope.row.reimbIncRecords, scope.row.reimbDecRecords, { table: 'opServiceLine', prop: 'apcFinancialImpact', index: scope.$index, row: scope.row }, $event, moneyFormatter(scope.row.financialImpact))"></div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination class="pager" v-if="isIE11" background :pager-count="15" layout="total, prev, pager, next" :page-size="itemsPerPage" :total="paginationTotal" @current-change="handleCurrentChange" :hide-on-single-page="hideOnSinglePage" small> </el-pagination>

    <el-pagination class="pager" v-if="isCodeGrouping()" background :pager-count="15" layout="total, prev, pager, next" :page-size="codeItemsPerPage" :total="paginationTotal" :current-page.sync="currentPage" @current-change="handleCurrentChange" :hide-on-single-page="hideOnSinglePage" small> </el-pagination>

    <el-popover ref="opDetailsPopOver" :visible-arrow="false" placement="bottom" width="400" trigger="click" @after-enter="handleHidePopOver">
      <DetailsPopOver :header="header" :popOverData="popOverData" :tableType="tableType" :reviewType="reviewType" :row="row" :rowMeta="rowMeta" :isOpen="isOpen" @tableTypeChange="handleTableTypeChange" @headerChange="header = $event"> </DetailsPopOver>
    </el-popover>
  </div>
</template>

<script>
import HiaAuthorization from '@/mixins/hiaAuthorization'
import money from '@/mixins/money'
import hiaFilters from '@/mixins/hiaFilters'
import DetailsPopOver from '@/views/Dashboards/DetailsPopOver'
import { mapState, mapActions, mapMutations } from 'vuex'
import { format, parseISO } from 'date-fns'

export default {
  data: function() {
    return {
      header: '',
      popperClickTarget: undefined,
      popOverData: [],
      tableType: '',
      reviewType: 'op',
      row: {},
      rowMeta: {},
      isOpen: false,
      currentPage: 1,
      itemsPerPage: 30,
      isIE11: !!navigator.userAgent.match(/Trident\/7\./),
      hideOnSinglePage: true,
      codeItemsPerPage: 60,
      sortProp: '',
      sortOrder: ''
    }
  },
  name: 'OutpatientTables',
  mixins: [HiaAuthorization, money, hiaFilters],
  props: {
    grouping: { type: String },
    codeTypeGrouping: { type: Array },
    dropdown: { type: Array },
    filterCriteria: { type: String },
    selectedGrouping: { type: Array },
    activateComparison: { type: Boolean },
    bedSize: { type: String }
  },
  components: {
    DetailsPopOver
  },
  methods: {
    ...mapActions('dashboard/', ['GET_DASHBOARD_PROJECTS']),
    ...mapMutations('dashboard/', ['CLEAR_DASHBOARD_ACCOUNTS']),
    moneyFormatter(value) {
      return `$${this.formatMoney(value)}`
    },
    handleTableTypeChange(newType) {
      this.tableType = newType
      if (newType === 'accountNumbers') {
        this.$nextTick(() => {
          this.$refs.opDetailsPopOver.$refs.popper.classList.add('largeCenterPopOver')
        })
      }
    },
    getTableData(grouping) {
      if (!this.reviewDashboardData) {
        return []
      }

      let opIndex = this.reviewDashboardData.findIndex(x => x.type === 'outpatient') > -1 ? this.reviewDashboardData.findIndex(x => x.type === 'outpatient') : null
      if (opIndex !== null && this.reviewDashboardData[opIndex].largeStats) {
        let groupIndex = this.reviewDashboardData[opIndex].largeStats.findIndex(x => x.title === grouping)
        let data = this.reviewDashboardData[opIndex].largeStats.some(x => x.title === grouping) ? this.reviewDashboardData[opIndex].largeStats[groupIndex].data : []

        if (this.filterCriteria.length) {
          data = this.filterList(data, this.filterCriteria)
        }

        if (this.codeTypeGrouping.length) {
          data = data.filter(x => {
            let val
            this.codeTypeGrouping.forEach(y => {
              if (x.codeDesc === y) {
                val = x
              }
            })
            return val
          })
        }

        if (this.selectedGrouping.length) {
          let groupKey = this.reviewDashboardData[opIndex].largeStats.some(x => x.title === grouping) ? this.reviewDashboardData[opIndex].largeStats[groupIndex].groupKey : ''
          data = data.filter(x => {
            let val
            this.selectedGrouping.forEach(y => {
              if (x[groupKey].toString() === y.toString()) {
                val = x
              }
            })
            return val
          })
        }

        return data
      }
      return []
    },
    buildPivotData(header, noRecs, adds, dels, revs, row, e, displayValue) {
      this.$nextTick(() => {
        this.tableType = 'stats'
        this.header = displayValue ? `${header} - ${displayValue}` : header
        this.popOverData = [{ title: 'Total Reviewed', value: noRecs + adds + dels + revs }, { title: 'Total Recommendations', value: adds + dels + revs }, { title: '', value: '' }, { title: 'No Recommendations', value: noRecs }, { title: 'Additions', value: adds }, { title: 'Deletions', value: dels }]
        // include revisions line for all except HCC
        if (!(row.table && (row.table === 'ophcc' || row.table === 'ophccv28'))) {
          this.popOverData.push({ title: 'Revisions', value: revs })
        }
        this.rowMeta = {
          table: row.table,
          prop: row.prop,
          codeNumber: row.row.codeNumber
        }
        this.row = row.row
        this.handleShowPopOver(row, e ? e.target : undefined)
      })
    },
    buildDxPopover(title, row, e, hccVersion) {
      this.clearPopOverData()
      this.$nextTick(() => {
        this.tableType = 'dxDashboard'
        this.header = `HCC ${title}`
        this.popOverData = []
        this.row = row
        this.row.hccVersion = hccVersion
        this.handleShowDetailsPopover(e.target)
      })
    },
    buildPivotDataStats(header, totalRecords, reimbInc, reimbDec, recordsWithRecommendations, row, e, displayValue) {
      this.$nextTick(() => {
        this.tableType = 'dataStats'
        this.header = displayValue ? `${header} - ${displayValue}` : header
        this.popOverData = [{ title: 'Number of Records', value: totalRecords }, { title: 'Record Recommendations', value: recordsWithRecommendations }, { title: 'Reimbursement Decrease', value: reimbDec }, { title: 'Reimbursement Increase', value: reimbInc }]
        this.rowMeta = {
          table: row.table,
          prop: 'mainDashboardGrouping',
          codeNumber: row.row.codeNumber
        }
        this.row = row.row
        this.handleShowPopOver(row, e ? e.target : undefined)
      })
    },
    buildPivotDataFinancials(header, financialImpact, reimbInc, reimbDec, reimbIncRecords, reimbDecRecords, row, e, displayValue) {
      this.$nextTick(() => {
        this.tableType = 'financial'
        this.header = displayValue ? `${header} - ${displayValue}` : header
        this.popOverData = [{ title: 'Reimbursement Diff', value: financialImpact }, { title: 'Reimbursement Decrease', value: reimbDec }, { title: 'Reimbursement Increase', value: reimbInc }, { title: 'Reimbursement Decrease Records', value: reimbDecRecords }, { title: 'Reimbursement Increase Records', value: reimbIncRecords }]
        this.rowMeta = {
          table: row.table,
          prop: row.prop,
          codeNumber: row.row.codeNumber
        }
        this.row = row.row
        this.handleShowPopOver(row, e ? e.target : undefined)
      })
    },
    buildAccountNumbers(title, row, e) {
      this.clearPopOverData()
      this.$nextTick(() => {
        this.tableType = 'accountNumbers'
        this.header = title
        this.popOverData = []
        this.row = row
        this.handleShowDetailsPopover(e.target)
      })
    },
    getSummaryData() {
      let data = this.isIE11 ? this.paginationSummaries : []
      if (this.isCodeGrouping()) {
        data = this.codeGroupingAllData
      }
      if (!data || !data.length) {
        switch (this.grouping) {
          case '1': data = this.coderTableData; break
          case '15': data = this.coderTrendingTableData; break
          case '2': data = this.apcTableData; break
          case '3': data = this.patientTypeTableData; break
          case '5': data = this.facilityTableData; break
          case '6': data = this.reasonTableData; break
          case '7': data = this.headerReasonTableData; break
          case '8': data = this.dxTableData; break
          case '14': data = this.sdohTableData; break
          case '9': data = this.cptTableData; break
          case '10': data = this.modTableData; break
          case '11': data = this.pxTableData; break
          case '12': data = this.hccTableData; break
          case '13': data = this.hccV28TableData; break
          case '16': data = this.serviceLineTableData; break
        }
      }
      return data || []
    },
    buildSummaryPivotData(columnProperty, targetElement) {
      let data = this.getSummaryData()
      if (!data.length) return

      const sum = (field) => data.reduce((t, r) => t + (isNaN(Number(r[field])) ? 0 : r[field]), 0)
      let allAccountNumbers = data.map(r => r.accountNumbers).filter(a => a).join(',')
      const fakeRow = { table: 'summary', prop: columnProperty, row: { accountNumbers: allAccountNumbers } }

      switch (columnProperty) {
        case 'totalCodes': {
          let noRecs = sum('dxNoRec') + sum('pxNoRec') + sum('cptNoRec') + sum('modNoRec') + sum('emNoRec') + sum('iiNoRec') + sum('siNoRec')
          let adds = sum('dxAdditions') + sum('pxAdditions') + sum('cptAdditions') + sum('modAdditions') + sum('emAdditions') + sum('iiAdditions') + sum('siAdditions')
          let dels = sum('dxDeletions') + sum('pxDeletions') + sum('cptDeletions') + sum('modDeletions') + sum('emDeletions') + sum('iiDeletions') + sum('siDeletions')
          let revs = sum('dxRevisions') + sum('pxRevisions') + sum('cptRevisions') + sum('modRevisions') + sum('emRevisions') + sum('iiRevisions') + sum('siRevisions')
          let tcRow = { table: 'summary', prop: 'opTotalCodes', row: { accountNumbers: allAccountNumbers } }
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          this.buildPivotData('Total Codes', noRecs, adds, dels, revs, tcRow, { target: targetElement }, displayValue)
          break
        }
        case 'cmCodes': {
          let noRecs, adds, dels, revs, label
          if (this.grouping === '8' || this.grouping === '14') {
            noRecs = sum('numOfNoRec'); adds = sum('numOfAdditions'); dels = sum('numOfDeletions'); revs = sum('numOfRevisions'); label = this.grouping === '14' ? 'SDOH Dx Accuracy Rate' : 'Dx Accuracy Rate'
          } else {
            noRecs = sum('dxNoRec'); adds = sum('dxAdditions'); dels = sum('dxDeletions'); revs = sum('dxRevisions'); label = 'ICD-10 CM Codes'
          }
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          this.buildPivotData(label, noRecs, adds, dels, revs, fakeRow, { target: targetElement }, displayValue)
          break
        }
        case 'pcsCodes': {
          let noRecs, adds, dels, revs, label
          if (this.grouping === '11') {
            noRecs = sum('numOfNoRec'); adds = sum('numOfAdditions'); dels = sum('numOfDeletions'); revs = sum('numOfRevisions'); label = 'Px Accuracy Rate'
          } else {
            noRecs = sum('pxNoRec'); adds = sum('pxAdditions'); dels = sum('pxDeletions'); revs = sum('pxRevisions'); label = 'ICD-10 PCS Codes'
          }
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          this.buildPivotData(label, noRecs, adds, dels, revs, fakeRow, { target: targetElement }, displayValue)
          break
        }
        case 'cptCodes': {
          let noRecs, adds, dels, revs, label
          if (this.grouping === '9') {
            noRecs = sum('numOfNoRec'); adds = sum('numOfAdditions'); dels = sum('numOfDeletions'); revs = sum('numOfRevisions'); label = 'CPT Accuracy Rate'
          } else {
            noRecs = sum('cptNoRec'); adds = sum('cptAdditions'); dels = sum('cptDeletions'); revs = sum('cptRevisions'); label = 'CPT Codes'
          }
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          this.buildPivotData(label, noRecs, adds, dels, revs, fakeRow, { target: targetElement }, displayValue)
          break
        }
        case 'modCodes': {
          let noRecs, adds, dels, revs, label
          if (this.grouping === '10') {
            noRecs = sum('numOfNoRec'); adds = sum('numOfAdditions'); dels = sum('numOfDeletions'); revs = sum('numOfRevisions'); label = 'MOD Accuracy Rate'
          } else {
            noRecs = sum('modNoRec'); adds = sum('modAdditions'); dels = sum('modDeletions'); revs = sum('modRevisions'); label = 'MOD Codes'
          }
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          this.buildPivotData(label, noRecs, adds, dels, revs, fakeRow, { target: targetElement }, displayValue)
          break
        }
        case 'apcCodes': {
          let noRecs = sum('apcNoRec'); let adds = sum('apcAdditions'); let dels = sum('apcDeletions'); let revs = sum('apcRevisions')
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          this.buildPivotData('Total APC', noRecs, adds, dels, revs, fakeRow, { target: targetElement }, displayValue)
          break
        }
        case 'emCodes': {
          let noRecs = sum('emNoRec'); let adds = sum('emAdditions'); let dels = sum('emDeletions'); let revs = sum('emRevisions')
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          this.buildPivotData('E/M Codes', noRecs, adds, dels, revs, fakeRow, { target: targetElement }, displayValue)
          break
        }
        case 'iiCodes': {
          let noRecs = sum('iiNoRec'); let adds = sum('iiAdditions'); let dels = sum('iiDeletions'); let revs = sum('iiRevisions')
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          this.buildPivotData('I&I Codes', noRecs, adds, dels, revs, fakeRow, { target: targetElement }, displayValue)
          break
        }
        case 'siCodes': {
          let noRecs = sum('siNoRec'); let adds = sum('siAdditions'); let dels = sum('siDeletions'); let revs = sum('siRevisions')
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          this.buildPivotData('S&I Codes', noRecs, adds, dels, revs, fakeRow, { target: targetElement }, displayValue)
          break
        }
        case 'financialImpact': {
          let fiDimension = this.grouping === '7' ? 'reimbDiff' : 'apcFinancialImpact'
          let fiRow = { table: 'summary', prop: fiDimension, row: { accountNumbers: allAccountNumbers } }
          let financialImpact = sum('financialImpact')
          let displayValue = this.moneyFormatter(financialImpact)
          if (this.grouping === '7') {
            this.buildPivotDataFinancials('Financial Stats', financialImpact, sum('reimbIncreases'), sum('reimbDecreases'), sum('recordsWithIncreases'), sum('recordsWithDecreases'), fiRow, { target: targetElement }, displayValue)
          } else {
            this.buildPivotDataFinancials('Financial Stats', financialImpact, sum('reimbInc'), sum('reimbDec'), sum('reimbIncRecords'), sum('reimbDecRecords'), fiRow, { target: targetElement }, displayValue)
          }
          break
        }
        case 'amt': {
          let amtRow = { table: 'summary', prop: 'apcFinancialImpact', row: { accountNumbers: allAccountNumbers } }
          let amt = sum('amt')
          let displayValue = this.moneyFormatter(amt)
          this.buildPivotDataFinancials('Financial Stats', amt, sum('reimbInc'), sum('reimbDec'), sum('reimbIncRecords'), sum('reimbDecRecords'), amtRow, { target: targetElement }, displayValue)
          break
        }
        case 'accuracyRate': {
          let dimension = this.grouping === '13' ? 'hccV28AccuracyRate' : 'hccV24AccuracyRate'
          let hccFakeRow = { table: 'summary', prop: dimension, row: { accountNumbers: allAccountNumbers } }
          let noRecs = sum('numOfNoRec'); let adds = sum('numOfAdditions'); let dels = sum('numOfDeletions'); let revs = sum('numOfRevisions')
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          let title = this.grouping === '13' ? 'HCC V28 Accuracy Rate' : 'HCC V24 Accuracy Rate'
          this.buildPivotData(title, noRecs, adds, dels, revs, hccFakeRow, { target: targetElement }, displayValue)
          break
        }
      }
    },
    buildSummaryAccountNumbers(targetElement) {
      let data = this.getSummaryData()
      if (!data.length) return
      let allAccountNumbers = data
        .map(r => r.accountNumbers)
        .filter(a => a)
        .join(',')
      if (!allAccountNumbers) return
      let syntheticRow = { accountNumbers: allAccountNumbers }
      this.clearPopOverData()
      this.$nextTick(() => {
        this.tableType = 'accountNumbers'
        this.header = 'Total Instances'
        this.popOverData = []
        this.row = syntheticRow
        this.handleShowDetailsPopover(targetElement)
      })
    },
    getActiveTableRef() {
      const map = {
        '1': 'opCoderTable',
'15': 'opCoderTrendingTable',
'2': 'opApcTable',
        '3': 'opPatientTypeTable',
'5': 'opFacilityTable',
'6': 'opReasonTable',
        '7': 'opHeaderReasonTable',
'8': 'opDxTable',
'14': 'opSdohTable',
        '9': 'opCptTable',
'10': 'opModTable',
'11': 'opPxTable',
        '12': 'opHCCTable',
'13': 'opHCCV28Table',
'16': 'opServiceLineTable'
      }
      return map[this.grouping] || null
    },
    attachSummaryClickHandlers() {
      this.cleanupSummaryHandlers()

      let tableRef = this.getActiveTableRef()
      if (!tableRef || !this.$refs[tableRef]) return

      let tableEl = this.$refs[tableRef].$el
      let footerWrapper = tableEl.querySelector('.el-table__footer-wrapper')
      if (!footerWrapper) return

      let footerCells = footerWrapper.querySelectorAll('td')
      let table = this.$refs[tableRef]
      let columns = table.columns || []

      const clickableColumns = [
        'totalRecords', 'numRecords', 'number',
        'totalCodes', 'cmCodes', 'pcsCodes', 'cptCodes', 'modCodes',
        'apcCodes', 'emCodes', 'iiCodes', 'siCodes',
        'financialImpact', 'amt', 'accuracyRate'
      ]

      footerCells.forEach((td, index) => {
        if (index >= columns.length) return
        let colProp = columns[index].property
        if (clickableColumns.includes(colProp)) {
          let cellText = td.textContent.trim()
          if (!cellText || cellText === 'N/A' || cellText === '' || cellText === '—') return

          td.classList.add('details')
          let handler = (e) => {
            e.stopPropagation()
            if (colProp === 'totalRecords' || colProp === 'numRecords' || colProp === 'number') {
              this.buildSummaryAccountNumbers(td)
            } else {
              this.buildSummaryPivotData(colProp, td)
            }
          }
          td.addEventListener('click', handler)
          this._summaryHandlers.push({ el: td, handler: handler })
        }
      })
    },
    cleanupSummaryHandlers() {
      if (this._summaryHandlers) {
        this._summaryHandlers.forEach(({ el, handler }) => {
          el.removeEventListener('click', handler)
          el.classList.remove('details')
        })
      }
      this._summaryHandlers = []
    },
    handleShowDetailsPopover(clickTarget) {
      let popper = this.$refs.opDetailsPopOver
      popper.doDestroy()
      popper.doClose()

      this.$nextTick(() => {
        this.popperClickTarget = clickTarget
        let reference = document.querySelector('#reviewDashboard')
        popper.doDestroy()
        popper.referenceElm = reference
        this.isOpen = true
        popper.$refs.popper.classList.add('largeCenterPopOver')
        popper.doShow()
        this.$nextTick(() => {
          this.$refs.opDetailsPopOver.$refs.popper.classList.add('largeCenterPopOver')
        })
      })
    },
    handleShowPopOver(row, targetElement) {
      let popper = this.$refs.opDetailsPopOver
      popper.doDestroy()
      popper.doClose()

      this.$nextTick(() => {
        this.popperClickTarget = targetElement || document.querySelector(`.${row.table}_${row.prop}_${row.index}`)
        popper.doDestroy()
        popper.referenceElm = this.popperClickTarget
        this.isOpen = true
        popper.doShow()
      })
    },
    handleHidePopOver() {
      let popper = this.$refs.opDetailsPopOver
      let handler = e => {
        if (e.target !== popper.$el && e.target !== this.popperClickTarget) {
          this.CLEAR_DASHBOARD_ACCOUNTS()
          popper.doClose()
          popper.doDestroy()
          this.clearClass()
        }
        document.removeEventListener('click', handler, false)
      }
      document.addEventListener('click', handler, false)
    },
    clearPopOverData() {
      this.CLEAR_DASHBOARD_ACCOUNTS()
      this.tableType = ''
      this.header = ''
      this.popOverData = []
      this.row = {}
      this.isOpen = false
    },
    clearClass() {
      let popper = this.$refs.opDetailsPopOver
      popper.$refs.popper.classList.remove('largeCenterPopOver')
    },
    getAPCSummary(param) {
      let { columns, data } = param
      const sums = []

      if (this.isIE11) {
        data = this.paginationSummaries
      }

      columns.forEach((column, index) => {
        switch (column.property) {
          case 'codeDesc':
            sums[index] = ''
            break
          case 'apc':
            sums[index] = ''
            break
          case 'patType':
            sums[index] = ''
            break
          case 'apcCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalAPCPercentSummary(column.property, data, index) : '—'
            break
          case 'financialImpact':
            let value = this.totalMoneySummary(column.property, data, index)
            let td = document.querySelector(`.el-table__footer .${column.id}`)
            if (td) {
              if (value.replace(/[$]|[,]/g, '') < 0 && this.codeTypeGrouping.length) {
                td.classList.add('negative_td')
              } else {
                td.classList.remove('negative_td')
              }
            }
            sums[index] = this.codeTypeGrouping.length === 1 ? value : '—'
            break
          default:
            sums[index] = 'n/a'
        }
      })

      return sums
    },
    getSummaries(param) {
      let { columns, data } = param
      const sums = []
      let value
      let td

      if (this.isIE11) {
        data = this.paginationSummaries
      }

      if (this.isCodeGrouping()) {
        data = this.codeGroupingAllData
      }

      columns.forEach((column, index) => {
        switch (column.property) {
          case 'codeDesc':
          case 'coder':
          case 'description':
          case 'patTypeDesc':
          case 'apc':
          case 'drName':
          case 'cliName':
          case 'changeReason':
          case 'changeDesc':
          case 'code':
          case 'clientServiceLineName':
            if (index === 0 || (this.activateComparison && this.comparisonAccountsOP.length && index === 1)) {
              sums[index] = 'Total'
            } else {
              sums[index] = ''
            }
            break
          case 'numRecords':
            sums[index] = this.totalSummary(column.property, data, index)
            break
          case 'totalRecords':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalSummary(column.property, data, index) : '—'
            break
          case 'totalOccurrences':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalSummary(column.property, data, index) : '—'
            break
          case 'number':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalSummary(column.property, data, index) : '—'
            break
          case 'accuracyRate':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'totalCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'cmCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'pcsCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'cptCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'modCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'apcCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'emCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'iiCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'siCodes':
            sums[index] = this.codeTypeGrouping.length === 1 ? this.totalPercentSummaries(column.property, data, index, column) : '—'
            break
          case 'financialImpact':
            value = this.totalMoneySummary(column.property, data, index)
            td = document.querySelector(`.el-table__footer .${column.id}`)
            if (td) {
              if (value.replace(/[$]|[,]/g, '') < 0 && this.codeTypeGrouping.length) {
                td.classList.add('negative_td')
              } else {
                td.classList.remove('negative_td')
              }
            }
            if (this.grouping !== '7') {
              sums[index] = this.codeTypeGrouping.length === 1 ? value : '—'
            } else {
              sums[index] = value
            }
            break
          case 'amt':
            value = this.totalMoneySummary(column.property, data, index)
            td = document.querySelector(`.el-table__footer .${column.id}`)
            if (td) {
              if (value.replace(/[$]|[,]/g, '') < 0 && this.codeTypeGrouping.length) {
                td.classList.add('negative_td')
              } else {
                td.classList.remove('negative_td')
              }
            }
            sums[index] = this.codeTypeGrouping.length === 1 ? value : '—'
            break
          default:
            sums[index] = 'N/A'
        }
      })

      return sums
    },
    totalPercentSummaries(column, data, index, columnArray) {
      let mt = 0
      let adr = 0
      for (let i = 0; i < data.length; i++) {
        // totalCodes Summary
        if (column === 'totalCodes') {
          if (!isNaN(Number(data[i]['dxNoRec'])) || !isNaN(Number(data[i]['dxAdditions'])) || !isNaN(Number(data[i]['dxDeletions'])) || !isNaN(Number(data[i]['dxRevisions'])) || !isNaN(Number(data[i]['pxNoRec'])) || !isNaN(Number(data[i]['pxAdditions'])) || !isNaN(Number(data[i]['pxDeletions'])) || !isNaN(Number(data[i]['pxRevisions'])) || !isNaN(Number(data[i]['cptNoRec'])) || !isNaN(Number(data[i]['cptAdditions'])) || !isNaN(Number(data[i]['cptDeletions'])) || !isNaN(Number(data[i]['cptRevisions'])) || !isNaN(Number(data[i]['modNoRec'])) || !isNaN(Number(data[i]['modAdditions'])) || !isNaN(Number(data[i]['modDeletions'])) || !isNaN(Number(data[i]['modRevisions'])) || !isNaN(Number(data[i]['emNoRec'])) || !isNaN(Number(data[i]['emAdditions'])) || !isNaN(Number(data[i]['emDeletions'])) || !isNaN(Number(data[i]['emRevisions'])) || !isNaN(Number(data[i]['iiNoRec'])) || !isNaN(Number(data[i]['iiAdditions'])) || !isNaN(Number(data[i]['iiDeletions'])) || !isNaN(Number(data[i]['iiRevisions'])) || !isNaN(Number(data[i]['siNoRec'])) || !isNaN(Number(data[i]['siAdditions'])) || !isNaN(Number(data[i]['siDeletions'])) || !isNaN(Number(data[i]['siRevisions']))) {
            mt += data[i]['dxNoRec'] + data[i]['dxAdditions'] + data[i]['dxDeletions'] + data[i]['dxRevisions'] + data[i]['pxNoRec'] + data[i]['pxAdditions'] + data[i]['pxDeletions'] + data[i]['pxRevisions'] + data[i]['cptNoRec'] + data[i]['cptAdditions'] + data[i]['cptDeletions'] + data[i]['cptRevisions'] + data[i]['modNoRec'] + data[i]['modAdditions'] + data[i]['modDeletions'] + data[i]['modRevisions'] + data[i]['emNoRec'] + data[i]['emAdditions'] + data[i]['emDeletions'] + data[i]['emRevisions'] + data[i]['iiNoRec'] + data[i]['iiAdditions'] + data[i]['iiDeletions'] + data[i]['iiRevisions'] + data[i]['siNoRec'] + data[i]['siAdditions'] + data[i]['siDeletions'] + data[i]['siRevisions']
          }

          if (!isNaN(Number(data[i]['dxAdditions'])) || !isNaN(Number(data[i]['dxDeletions'])) || !isNaN(Number(data[i]['dxRevisions'])) || !isNaN(Number(data[i]['pxAdditions'])) || !isNaN(Number(data[i]['pxDeletions'])) || !isNaN(Number(data[i]['pxRevisions'])) || !isNaN(Number(data[i]['cptAdditions'])) || !isNaN(Number(data[i]['cptDeletions'])) || !isNaN(Number(data[i]['cptRevisions'])) || !isNaN(Number(data[i]['modAdditions'])) || !isNaN(Number(data[i]['modDeletions'])) || !isNaN(Number(data[i]['modRevisions'])) || !isNaN(Number(data[i]['emAdditions'])) || !isNaN(Number(data[i]['emDeletions'])) || !isNaN(Number(data[i]['emRevisions'])) || !isNaN(Number(data[i]['iiAdditions'])) || !isNaN(Number(data[i]['iiDeletions'])) || !isNaN(Number(data[i]['iiRevisions'])) || !isNaN(Number(data[i]['siAdditions'])) || !isNaN(Number(data[i]['siDeletions'])) || !isNaN(Number(data[i]['siRevisions']))) {
            adr += data[i]['dxAdditions'] + data[i]['dxDeletions'] + data[i]['dxRevisions'] + data[i]['pxAdditions'] + data[i]['pxDeletions'] + data[i]['pxRevisions'] + data[i]['cptAdditions'] + data[i]['cptDeletions'] + data[i]['cptRevisions'] + data[i]['modAdditions'] + data[i]['modDeletions'] + data[i]['modRevisions'] + data[i]['emAdditions'] + data[i]['emDeletions'] + data[i]['emRevisions'] + data[i]['iiAdditions'] + data[i]['iiDeletions'] + data[i]['iiRevisions'] + data[i]['siAdditions'] + data[i]['siDeletions'] + data[i]['siRevisions']
          }
        }

        // cmCodes Summary
        if (column === 'cmCodes') {
          if (!isNaN(Number(data[i]['dxNoRec'])) || !isNaN(Number(data[i]['dxAdditions'])) || !isNaN(Number(data[i]['dxDeletions'])) || !isNaN(Number(data[i]['dxRevisions']))) {
            mt += data[i]['dxNoRec'] + data[i]['dxAdditions'] + data[i]['dxDeletions'] + data[i]['dxRevisions']
          }

          if (!isNaN(Number(data[i]['dxAdditions'])) || !isNaN(Number(data[i]['dxDeletions'])) || !isNaN(Number(data[i]['dxRevisions']))) {
            adr += data[i]['dxAdditions'] + data[i]['dxDeletions'] + data[i]['dxRevisions']
          }
        }

        // pcsCodes Summary
        if (column === 'pcsCodes') {
          if (!isNaN(Number(data[i]['pxNoRec'])) || !isNaN(Number(data[i]['pxAdditions'])) || !isNaN(Number(data[i]['pxDeletions'])) || !isNaN(Number(data[i]['pxRevisions']))) {
            mt += data[i]['pxNoRec'] + data[i]['pxAdditions'] + data[i]['pxDeletions'] + data[i]['pxRevisions']
          }

          if (!isNaN(Number(data[i]['pxAdditions'])) || !isNaN(Number(data[i]['pxDeletions'])) || !isNaN(Number(data[i]['pxRevisions']))) {
            adr += data[i]['pxAdditions'] + data[i]['pxDeletions'] + data[i]['pxRevisions']
          }
        }

        // cptCodes
        if (column === 'cptCodes') {
          if (!isNaN(Number(data[i]['cptNoRec'])) || !isNaN(Number(data[i]['cptAdditions'])) || !isNaN(Number(data[i]['cptDeletions'])) || !isNaN(Number(data[i]['cptRevisions']))) {
            mt += data[i]['cptNoRec'] + data[i]['cptAdditions'] + data[i]['cptDeletions'] + data[i]['cptRevisions']
          }

          if (!isNaN(Number(data[i]['cptAdditions'])) || !isNaN(Number(data[i]['cptDeletions'])) || !isNaN(Number(data[i]['cptRevisions']))) {
            adr += data[i]['cptAdditions'] + data[i]['cptDeletions'] + data[i]['cptRevisions']
          }
        }

        // modCodes
        if (column === 'modCodes') {
          if (!isNaN(Number(data[i]['modNoRec'])) || !isNaN(Number(data[i]['modAdditions'])) || !isNaN(Number(data[i]['modDeletions'])) || !isNaN(Number(data[i]['modRevisions']))) {
            mt += data[i]['modNoRec'] + data[i]['modAdditions'] + data[i]['modDeletions'] + data[i]['modRevisions']
          }

          if (!isNaN(Number(data[i]['modAdditions'])) || !isNaN(Number(data[i]['modDeletions'])) || !isNaN(Number(data[i]['modRevisions']))) {
            adr += data[i]['modAdditions'] + data[i]['modDeletions'] + data[i]['modRevisions']
          }
        }

        // apcCodes
        if (column === 'apcCodes') {
          if (!isNaN(Number(data[i]['apcNoRec'])) || !isNaN(Number(data[i]['apcAdditions'])) || !isNaN(Number(data[i]['apcDeletions'])) || !isNaN(Number(data[i]['apcRevisions']))) {
            mt += data[i]['apcNoRec'] + data[i]['apcAdditions'] + data[i]['apcDeletions'] + data[i]['apcRevisions']
          }

          if (!isNaN(Number(data[i]['apcAdditions'])) || !isNaN(Number(data[i]['apcDeletions'])) || !isNaN(Number(data[i]['apcRevisions']))) {
            adr += data[i]['apcAdditions'] + data[i]['apcDeletions'] + data[i]['apcRevisions']
          }
        }

        // emCodes
        if (column === 'emCodes') {
          if (!isNaN(Number(data[i]['emNoRec'])) || !isNaN(Number(data[i]['emAdditions'])) || !isNaN(Number(data[i]['emDeletions'])) || !isNaN(Number(data[i]['emRevisions']))) {
            mt += data[i]['emNoRec'] + data[i]['emAdditions'] + data[i]['emDeletions'] + data[i]['emRevisions']
          }

          if (!isNaN(Number(data[i]['emAdditions'])) || !isNaN(Number(data[i]['emDeletions'])) || !isNaN(Number(data[i]['emRevisions']))) {
            adr += data[i]['emAdditions'] + data[i]['emDeletions'] + data[i]['emRevisions']
          }
        }

        // iiCodes
        if (column === 'iiCodes') {
          if (!isNaN(Number(data[i]['iiNoRec'])) || !isNaN(Number(data[i]['iiAdditions'])) || !isNaN(Number(data[i]['iiDeletions'])) || !isNaN(Number(data[i]['iiRevisions']))) {
            mt += data[i]['iiNoRec'] + data[i]['iiAdditions'] + data[i]['iiDeletions'] + data[i]['iiRevisions']
          }

          if (!isNaN(Number(data[i]['iiAdditions'])) || !isNaN(Number(data[i]['iiDeletions'])) || !isNaN(Number(data[i]['iiRevisions']))) {
            adr += data[i]['iiAdditions'] + data[i]['iiDeletions'] + data[i]['iiRevisions']
          }
        }

        // siCodes
        if (column === 'siCodes') {
          if (!isNaN(Number(data[i]['siNoRec'])) || !isNaN(Number(data[i]['siAdditions'])) || !isNaN(Number(data[i]['siDeletions'])) || !isNaN(Number(data[i]['siRevisions']))) {
            mt += data[i]['siNoRec'] + data[i]['siAdditions'] + data[i]['siDeletions'] + data[i]['siRevisions']
          }

          if (!isNaN(Number(data[i]['siAdditions'])) || !isNaN(Number(data[i]['siDeletions'])) || !isNaN(Number(data[i]['siRevisions']))) {
            adr += data[i]['siAdditions'] + data[i]['siDeletions'] + data[i]['siRevisions']
          }
        }

        // dx table accuracy rate
        if (columnArray.label === 'Accuracy Rate') {
          if (!isNaN(Number(data[i]['numOfNoRec'])) || !isNaN(Number(data[i]['numOfAdditions'])) || !isNaN(Number(data[i]['numOfDeletions'])) || !isNaN(Number(data[i]['numOfRevisions']))) {
            mt += data[i]['numOfNoRec'] + data[i]['numOfAdditions'] + data[i]['numOfDeletions'] + data[i]['numOfRevisions']
          }

          if (!isNaN(Number(data[i]['numOfAdditions'])) || !isNaN(Number(data[i]['numOfDeletions'])) || !isNaN(Number(data[i]['numOfRevisions']))) {
            adr += data[i]['numOfAdditions'] + data[i]['numOfDeletions'] + data[i]['numOfRevisions']
          }
        }
      }

      return mt || adr ? this.calculatePercentages(mt, adr) : 'N/A'
    },
    totalAPCPercentSummary(column, data, index) {
      let mt = 0
      let adr = 0
      for (let i = 0; i < data.length; i++) {
        // apcCodes
        if (column === 'apcCodes') {
          if (!isNaN(Number(data[i]['noRec'])) || !isNaN(Number(data[i]['additions'])) || !isNaN(Number(data[i]['deletions'])) || !isNaN(Number(data[i]['revisions']))) {
            mt += data[i]['noRec'] + data[i]['additions'] + data[i]['deletions'] + data[i]['revisions']
          }

          if (!isNaN(Number(data[i]['additions'])) || !isNaN(Number(data[i]['deletions'])) || !isNaN(Number(data[i]['revisions']))) {
            adr += data[i]['additions'] + data[i]['deletions'] + data[i]['revisions']
          }
        }
      }
      return this.calculatePercentages(mt, adr)
    },
    totalSummary(column, data, index) {
      // let groupValue = this.dropdown.filter(x => x.key === this.grouping)[0]
      let response = data.reduce((total, curr) => {
        const value = Number(curr[column])
        if (!isNaN(value)) {
          return total + curr[column]
        } else {
          return total
        }
      }, 0)

      return response
    },
    totalMoneySummary(column, data, index) {
      let response = data.reduce((total, curr) => {
        const value = Number(curr[column])
        if (!isNaN(value)) {
          return total + curr[column]
        } else {
          return total
        }
      }, 0)
      return this.moneyFormatter(response)
    },
    calculatePercentages(masterTotal, adrTotal) {
      let response = masterTotal === null || masterTotal === 0 ? 0 : 1 - adrTotal / masterTotal
      return `${(response * 100).toFixed(2)}%`
    },
    checkPercentValues(column, scope, table) {
      let response = false
      switch (column) {
        case 'Total APC':
          if (table === 'apc') {
            if (!scope.row.noRec && !scope.row.additions && !scope.row.deletions && !scope.row.revisions) {
              response = true
            }
          } else {
            if (!scope.row.apcNoRec && !scope.row.apcAdditions && !scope.row.apcDeletions && !scope.row.apcRevisions) {
              response = true
            }
          }
          break
        case 'Total Codes':
          if (!scope.row.dxNoRec && !scope.row.pxNoRec && !scope.row.cptNoRec && !scope.row.modNoRec && !scope.row.emNoRec && !scope.row.iiNoRec && !scope.row.siNoRec && !scope.row.dxAdditions && !scope.row.pxAdditions && !scope.row.cptAdditions && !scope.row.modAdditions && !scope.row.emAdditions && !scope.row.iiAdditions && !scope.row.siAdditions && !scope.row.dxDeletions && !scope.row.pxDeletions && !scope.row.cptDeletions && !scope.row.modDeletions && !scope.row.emDeletions && !scope.row.iiDeletions && !scope.row.siDeletions && !scope.row.dxRevisions && !scope.row.pxRevisions && !scope.row.cptRevisions && !scope.row.modRevisions && !scope.row.emRevisions && !scope.row.iiRevisions && !scope.row.siRevisions) {
            response = true
          }
          break
        case 'ICD-10 CM Codes':
          if (!scope.row.dxNoRec && !scope.row.dxAdditions && !scope.row.dxDeletions && !scope.row.dxRevisions) {
            response = true
          }
          break
        case 'ICD-10 PCS Codes':
          if (!scope.row.pxNoRec && !scope.row.pxAdditions && !scope.row.pxDeletions && !scope.row.pxRevisions) {
            response = true
          }
          break
        case 'CPT Codes':
          if (!scope.row.cptNoRec && !scope.row.cptAdditions && !scope.row.cptDeletions && !scope.row.cptRevisions) {
            response = true
          }
          break
        case 'MOD Codes':
          if (!scope.row.modNoRec && !scope.row.modAdditions && !scope.row.modDeletions && !scope.row.modRevisions) {
            response = true
          }
          break
        case 'E/M Codes':
          if (!scope.row.emNoRec && !scope.row.emAdditions && !scope.row.emDeletions && !scope.row.emRevisions) {
            response = true
          }
          break
        case 'I&I Codes':
          if (!scope.row.iiNoRec && !scope.row.iiAdditions && !scope.row.iiDeletions && !scope.row.iiRevisions) {
            response = true
          }
          break
        case 'S&I Codes':
          if (!scope.row.siNoRec && !scope.row.siAdditions && !scope.row.siDeletions && !scope.row.siRevisions) {
            response = true
          }
          break
        case 'dx cmCodes':
          if (!scope.row.numOfAdditions && !scope.row.numOfDeletions && !scope.row.numOfNoRec && !scope.row.numOfRevisions) {
            response = true
          }
          break
      }

      return response
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    handleSortChange({ prop, order }) {
      this.sortProp = prop
      this.sortOrder = order
      this.currentPage = 1
    },
    sortData(data) {
      if (!this.sortProp || !this.sortOrder) return data
      const sorted = [...data]
      const modifier = this.sortOrder === 'ascending' ? 1 : -1
      sorted.sort((a, b) => {
        const valA = a[this.sortProp]
        const valB = b[this.sortProp]
        if (valA == null && valB == null) return 0
        if (valA == null) return 1
        if (valB == null) return -1
        if (typeof valA === 'string') return valA.localeCompare(valB) * modifier
        return (valA - valB) * modifier
      })
      return sorted
    },
    getBedSizeValue(groupKey, value, prop, codeType, allData, patType = null, table = '') {
      let response = '—'
      if (this.comparisonAccountsOP.length) {
        let index

        switch (table) {
          case 'dx':
            index = allData ? this.comparisonAccountsOP.findIndex(x => x.groupKey === groupKey && x.type === 'outpatient all review' && x.title === 'By Dx') : this.comparisonAccountsOP.findIndex(x => x.groupKey === groupKey && x.type === 'outpatient bedsize review' && x.title === 'By Dx')
            break
          case 'sdoh':
            index = allData ? this.comparisonAccountsOP.findIndex(x => x.groupKey === groupKey && x.type === 'outpatient all review' && x.title === 'By SDOH Dx') : this.comparisonAccountsOP.findIndex(x => x.groupKey === groupKey && x.type === 'outpatient bedsize review' && x.title === 'By SDOH Dx')
            break
          case 'hcc':
            index = allData ? this.comparisonAccountsOP.findIndex(x => x.groupKey === groupKey && x.type === 'outpatient all review' && x.title === 'By HCC') : this.comparisonAccountsOP.findIndex(x => x.groupKey === groupKey && x.type === 'outpatient bedsize review' && x.title === 'By HCC')
            break
          case 'hccv28':
            index = allData ? this.comparisonAccountsOP.findIndex(x => x.groupKey === groupKey && x.type === 'outpatient all review' && x.title === 'By HCC V28') : this.comparisonAccountsOP.findIndex(x => x.groupKey === groupKey && x.type === 'outpatient bedsize review' && x.title === 'By HCC V28')
            break
          case 'px':
            index = allData ? this.comparisonAccountsOP.findIndex(x => x.groupKey === groupKey && x.type === 'outpatient all review' && x.title === 'By Px') : this.comparisonAccountsOP.findIndex(x => x.groupKey === groupKey && x.type === 'outpatient bedsize review' && x.title === 'By Px')
            break
          case 'cpt':
            index = allData ? this.comparisonAccountsOP.findIndex(x => x.groupKey === groupKey && x.type === 'outpatient all review' && x.title === 'By CPT') : this.comparisonAccountsOP.findIndex(x => x.groupKey === groupKey && x.type === 'outpatient bedsize review' && x.title === 'By CPT')
            break
          case 'mod':
            index = allData ? this.comparisonAccountsOP.findIndex(x => x.groupKey === groupKey && x.type === 'outpatient all review' && x.title === 'By MOD') : this.comparisonAccountsOP.findIndex(x => x.groupKey === groupKey && x.type === 'outpatient bedsize review' && x.title === 'By MOD')
            break
          default:
            index = allData ? this.comparisonAccountsOP.findIndex(x => x.groupKey === groupKey && x.type === 'outpatient all review') : this.comparisonAccountsOP.findIndex(x => x.groupKey === groupKey && x.type === 'outpatient bedsize review')
        }

        if (index !== -1) {
          let found = {}
          if (groupKey === 'cliName') {
            found = this.comparisonAccountsOP[index].data.find(x => x.codeDesc === codeType)
          } else {
            found = patType === null ? this.comparisonAccountsOP[index].data.find(x => x[groupKey] === value && x.codeDesc === codeType) : this.comparisonAccountsOP[index].data.find(x => x[groupKey] === value && x.codeDesc === codeType && x.patType === patType)
          }
          if (found) {
            let percents = ['apcCodes', 'totalCodes', 'cmCodes', 'pcsCodes', 'cptCodes', 'modCodes', 'emCodes', 'iiCodes', 'siCodes', 'accuracyRate']
            let money = ['financialImpact', 'amt']
            response = found[prop]
            // display formats
            if (percents.some(x => x === prop)) {
              response = `${(found[prop] * 100).toFixed(2)}%`
            }

            if (money.some(x => x === prop)) {
              response = this.moneyFormatter(found[prop])
            }
          }
          return response
        }
      }
      return response
    },
    isCodeGrouping() {
      return ['8', '9', '11', '12', '13', '14'].includes(this.grouping) && !this.isIE11
    },
    convertHccs(delimited) {
      if (delimited) {
        let retArray = delimited.split('-')
        if (retArray) {
          return retArray
        }
      }
      return []
    },
    getHccTitle(id) {
      if (id) {
        let data = []
        let ipIndex = this.reviewDashboardData.findIndex(x => x.type === 'outpatient') > -1 ? this.reviewDashboardData.findIndex(x => x.type === 'outpatient') : null
        let grouping = 'HCCs'
        let groupIndex = this.reviewDashboardData[ipIndex].largeStats.findIndex(x => x.title === grouping)
        data = this.reviewDashboardData[ipIndex].largeStats.some(x => x.title === grouping) ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].data : []

        let filteredList = data.filter(a => a.hccId === id)
        if (filteredList[0]) {
          return filteredList[0].description
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    formatDate(date) {
      return format(parseISO(date), 'MM/dd/yyyy')
    }
  },
  created: function() {
    this._summaryHandlers = []
  },
  mounted() {
    this.$nextTick(() => {
      this.attachSummaryClickHandlers()
    })
  },
  updated() {
    this.$nextTick(() => {
      this.attachSummaryClickHandlers()
    })
  },
  beforeDestroy() {
    this.cleanupSummaryHandlers()
  },
  watch: {
    grouping() {
      this.currentPage = 1
      this.sortProp = ''
      this.sortOrder = ''
    },
    reviewDashboardData: {
      handler() {
        this.$nextTick(() => {
          let tableRef = this.getActiveTableRef()
          if (tableRef && this.$refs[tableRef]) {
            this.$refs[tableRef].doLayout()
          }
          this.$nextTick(() => {
            this.attachSummaryClickHandlers()
          })
        })
      },
      deep: true
    }
  },
  computed: {
    ...mapState('user/', ['currentClient', 'currentClientId']),
    ...mapState('dashboard/', ['dashboardData', 'dashboardProjects', 'reviewDashboardData', 'comparisonAccountsOP']),
    coderTableData() {
      return this.getTableData('By Coder')
    },
    coderTrendingTableData() {
      return this.getTableData('By Coder Trending')
    },
    patientTypeTableData() {
      return this.getTableData('By Patient Type')
    },
    apcTableData() {
      return this.getTableData('By APC')
    },
    facilityTableData() {
      return this.getTableData('By Facility')
    },
    reasonTableData() {
      return this.getTableData('By Reason')
    },
    headerReasonTableData() {
      return this.getTableData('By Header Reason')
    },
    dxTableData() {
      return this.getTableData('By Dx')
    },
    sdohTableData() {
      return this.getTableData('By SDOH Dx')
    },
    cptTableData() {
      return this.getTableData('By CPT')
    },
    modTableData() {
      return this.getTableData('By MOD')
    },
    pxTableData() {
      return this.getTableData('By Px')
    },
    hccTableData() {
      return this.getTableData('By HCC')
    },
    hccV28TableData() {
      return this.getTableData('By HCC V28')
    },
    serviceLineTableData() {
      return this.getTableData('By Service Line')
    },
    coderTablePagination() {
      let length = this.coderTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.coderTableData.slice(from, to)
    },
    coderTrendingTablePagination() {
      let length = this.coderTrendingTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.coderTrendingTableData.slice(from, to)
    },
    patientTypeTablePagination() {
      let length = this.patientTypeTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.patientTypeTableData.slice(from, to)
    },
    apcTableDataPagination() {
      let length = this.apcTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.apcTableData.slice(from, to)
    },
    facilityTablePagination() {
      let length = this.facilityTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.facilityTableData.slice(from, to)
    },
    reasonTablePagination() {
      let length = this.reasonTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.reasonTableData.slice(from, to)
    },
    headerReasonTablePagniation() {
      let length = this.headerReasonTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.headerReasonTableData.slice(from, to)
    },
    dxTablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.dxTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.dxTableData).slice(from, to)
    },
    sdohTablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.sdohTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.sdohTableData).slice(from, to)
    },
    hccTablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.hccTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.hccTableData).slice(from, to)
    },
    hccV28TablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.hccV28TableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.hccV28TableData).slice(from, to)
    },
    cptTablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.cptTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.cptTableData).slice(from, to)
    },
    modTablePagination() {
      let length = this.modTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.modTableData.slice(from, to)
    },
    pxTablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.pxTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.pxTableData).slice(from, to)
    },
    serviceLineTablePagination() {
      let length = this.serviceLineTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.serviceLineTableData.slice(from, to)
    },
    paginationTotal() {
      let length = 0
      switch (this.grouping) {
        case '1':
          length = this.coderTableData.length
          break
        case '15':
          length = this.coderTrendingTableData.length
          break
        case '2':
          length = this.apcTableData.length
          break
        case '3':
          length = this.patientTypeTableData.length
          break
        case '5':
          length = this.facilityTableData.length
          break
        case '6':
          length = this.reasonTableData.length
          break
        case '7':
          length = this.headerReasonTableData.length
          break
        case '8':
          length = this.dxTableData.length
          break
        case '14':
          length = this.sdohTableData.length
          break
        case '9':
          length = this.cptTableData.length
          break
        case '10':
          length = this.modTableData.length
          break
        case '11':
          length = this.pxTableData.length
          break
        case '12':
          length = this.hccTableData.length
          break
        case '13':
          length = this.hccV28TableData.length
          break
        case '16':
          length = this.serviceLineTableData.length
          break
      }
      return length
    },
    paginationSummaries() {
      let data = []
      switch (this.grouping) {
        case '1':
          data = this.coderTableData
          break
        case '15':
          data = this.coderTrendingTableData
          break
        case '2':
          data = this.apcTableData
          break
        case '3':
          data = this.patientTypeTableData
          break
        case '5':
          data = this.facilityTableData
          break
        case '6':
          data = this.reasonTableData
          break
        case '7':
          data = this.headerReasonTableData
          break
        case '8':
          data = this.dxTableData
          break
        case '14':
          data = this.sdohTableData
          break
        case '9':
          data = this.cptTableData
          break
        case '10':
          data = this.modTableData
          break
        case '11':
          data = this.pxTableData
          break
        case '12':
          data = this.hccTableData
          break
        case '13':
          data = this.hccV28TableData
          break
        case '16':
          data = this.serviceLineTableData
          break
      }
      return data
    },
    codeGroupingAllData() {
      let data = []
      switch (this.grouping) {
        case '8':
          data = this.dxTableData
          break
        case '14':
          data = this.sdohTableData
          break
        case '9':
          data = this.cptTableData
          break
        case '11':
          data = this.pxTableData
          break
        case '12':
          data = this.hccTableData
          break
        case '13':
          data = this.hccV28TableData
          break
      }
      return data
    }
  }
}
</script>

<style scoped>
/* .negative {
    color: #f56c6c;
  }

  .negative::before {
    content: '(';
  }

  .negative::after {
    content: ')';
  } */

/* Element UI: sort changes header height but does not rerun layout; body-wrapper keeps a stale
   inline height so header + body + summary exceeds fixed height and the footer is clipped. */
#opData >>> .el-table {
  display: flex;
  flex-direction: column;
}
#opData >>> .el-table__header-wrapper,
#opData >>> .el-table__footer-wrapper {
  flex-shrink: 0;
}
#opData >>> .el-table__body-wrapper {
  flex: 1 1 0;
  min-height: 0;
  height: auto !important;
}
</style>
